import { render } from "./Custodian.vue?vue&type=template&id=2020bf87&ts=true"
import script from "./Custodian.vue?vue&type=script&lang=ts"
export * from "./Custodian.vue?vue&type=script&lang=ts"

import "./Custodian.vue?vue&type=style&index=0&id=2020bf87&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__